import { H3 } from '@h3/types';
import { request } from '@h3/request';
import * as Api from './constant';
// 请求头
const headers = {
    'Content-Type': H3.Http.ContentType.FORM_URLENCODED,
};
/**
 * 甘特图升降级
 * @param params
 * @returns
 */
export const updateGanttTaskLevel = (params) => {
    return request(Api.UpdateGanttTaskLevelUrl, {
        method: 'post',
        data: params,
        disableBizError: true,
    });
};
/**
 * 更新任务类型
 * @param params
 * @returns
 */
export const updateGanttTaskType = (params) => {
    return request(Api.UpdateGanttTaskTypeUrl, {
        method: 'post',
        data: params,
        disableBizError: true,
    });
};
/**
 * 任务排序
 * @param params
 * @returns
 */
export const updateGanttTaskSort = (params) => {
    return request(Api.UpdateGanttTaskSortUrl, {
        method: 'post',
        data: params,
        disableBizError: true,
    });
};
/**
 * 任务新增(后续Q3)
 * @param params
 * @returns
 */
export const createGanttTask = (params) => {
    return request(Api.QueryViewBizDataUrl, {
        method: 'post',
        data: params,
    });
};
/**
 * 任务更新(后续Q3)
 * @param params
 * @returns
 */
export const updateGanttTask = (params) => {
    return request(Api.UpdateGanttTaskUrl, {
        method: 'post',
        data: params,
    });
};
/**
 * 更新所属依赖
 * @param params
 * @returns
 */
export const updateGanttTaskDependency = (params) => {
    return request(Api.UpdateGanttTaskDependencyUrl, {
        method: 'post',
        data: params,
    });
};
/**
 * 更新task表单数据(旧接口)
 * @param params
 * @returns
 */
export const updateGanttTaskForm = (params) => {
    return request('/GanttChart/OnAction', {
        method: 'post',
        data: {
            PostData: JSON.stringify(params),
        },
        headers,
        requestType: 'form',
        disableBizError: true,
    });
};
/**
 * 删除task(旧接口)
 * @param params
 * @returns
 */
export const deleteGanttTaskForm = (params) => {
    return request('/App/OnAction', {
        method: 'post',
        data: {
            PostData: JSON.stringify(params),
        },
        headers,
        requestType: 'form',
        disableBizError: true,
    });
};
/**
 * 更新所属依赖(旧接口)
 * @param params
 * @returns
 */
export const updateGanttTaskFormDependency = (params) => {
    return request('/GanttChart/OnAction', {
        method: 'post',
        data: {
            PostData: JSON.stringify(params),
        },
        headers,
        requestType: 'form',
        disableBizError: true,
    });
};
